import { render } from "./MLDemoIndex.vue?vue&type=template&id=5c193bea&scoped=true"
import script from "./MLDemoIndex.vue?vue&type=script&lang=js"
export * from "./MLDemoIndex.vue?vue&type=script&lang=js"

import "./MLDemoIndex.vue?vue&type=style&index=0&id=5c193bea&lang=less"
import "./MLDemoIndex.vue?vue&type=style&index=1&id=5c193bea&scoped=true&lang=css"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c193bea"]])

export default __exports__